import { render, staticRenderFns } from "./QuantitiesUsedInBoms.vue?vue&type=template&id=b3e95c80&scoped=true&"
import script from "./QuantitiesUsedInBoms.vue?vue&type=script&lang=js&"
export * from "./QuantitiesUsedInBoms.vue?vue&type=script&lang=js&"
import style0 from "./QuantitiesUsedInBoms.vue?vue&type=style&index=0&id=b3e95c80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3e95c80",
  null
  
)

export default component.exports